module.exports = __webpack_public_path__ + "08001b1afc6ca7f48997aba75965a6f2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/hamburger.svg
// module id = 290
// module chunks = 16